import React from 'react';

import { Box, BoxProps, styled } from '@mui/material';

export const MainWrapper = styled(({ children, ...props }: BoxProps) => (
   <Box component='main' {...props}>
      {children}
   </Box>
))(() => ({
   width: '100%',
   // Matches App layout: subtract fixed app bar only when authenticated (see App.tsx --app-chrome-top)
   height: 'calc(100vh - var(--app-chrome-top, 0px))',
   display: 'flex',
   flexDirection: 'row',
   overflow: 'hidden',
}));
